export const leaderboardQueryKeys = {
  all: ['leaderboard'],
  classExp: (classId) => ['leaderboard', 'classExp', classId],
  family: (parentUid) => ['leaderboard', 'family', parentUid ?? ''],
  missionQuest: (uid, classId, schoolId) => [
    'leaderboard',
    'missionQuest',
    uid,
    classId ?? '',
    schoolId ?? ''
  ]
}
